module.exports = __webpack_public_path__ + "static/VG5000-Regular_web-06f3fbd0f7dcabf60012045bdd5d83ac.ttf";